import React from 'react';
import { getSentry } from '../utils/sentry';
import { reportError } from '../utils/errorReporter';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    const Sentry = getSentry();
    if (Sentry) {
      Sentry.captureException(error, {
        extra: { componentStack: errorInfo.componentStack }
      });
    }
    // 2026-05-26 — also forward to the Day Dashboard's
    // /api/frontend-error so we can correlate this crash with the
    // server requests that preceded it (last_api_calls bundle the
    // request_ids; clicking through in the dashboard shows the
    // exact slow request / DB query that fired before the boundary).
    try {
      reportError({
        category: 'unhandled',
        message: (error && error.message) || String(error || 'ErrorBoundary'),
        stack: (error && error.stack) || '',
        componentStack: (errorInfo && errorInfo.componentStack) || '',
      });
    } catch { /* never throw */ }
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          background: '#f4f6f9',
          direction: 'rtl',
          fontFamily: 'system-ui, sans-serif',
        }}>
          <div style={{
            background: 'white',
            padding: 40,
            borderRadius: 8,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            textAlign: 'center',
            maxWidth: 500,
          }}>
            <h2 style={{ color: '#d32f2f', marginBottom: 16 }}>
              {'\u05E9\u05D2\u05D9\u05D0\u05D4 \u05D1\u05DC\u05EA\u05D9 \u05E6\u05E4\u05D5\u05D9\u05D4'}
            </h2>
            <p style={{ color: '#666', marginBottom: 24 }}>
              {'\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4. \u05D0\u05E0\u05D0 \u05E8\u05E2\u05E0\u05DF \u05D0\u05EA \u05D4\u05D3\u05E3 \u05D5\u05E0\u05E1\u05D4 \u05E9\u05E0\u05D9\u05EA.'}
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: '#0176d3',
                color: 'white',
                border: 'none',
                padding: '10px 32px',
                borderRadius: 4,
                cursor: 'pointer',
                fontSize: 16,
              }}
            >
              {'\u05E8\u05E2\u05E0\u05DF \u05D3\u05E3'}
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
